let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aP9rL")).then(() => parcelRequire('2HwUT'));